import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import FloatingAdd from "./FloatingAdd";
import ExpenseForm from "./ExpenseForm";
import HomeExpenseForm from "../../home/form/HomeExpenseForm";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: '96vw',
  maxWidth:'380px',
  m:'1',
  bgcolor: "background.paper",
  borderRadius: "8px",
  p: 2,
  py: 4,
};

export default function ModalForm() {
  const [open, setOpen] = React.useState(false);
  const [formType, setFormType] = React.useState("room_expense");
  const navigate=useNavigate();
  const handleOpen = (type) => {
    setFormType(type);
    if(type==='home_expense')
      navigate(`../home`)
    if(type==='room_expense')
      navigate(`../panel`)
    setOpen(true);
  }
  const handleClose = () => setOpen(false);

  // React.useEffect(() => {
  //   setTimeout(() => {
  //     handleOpen();
  //   }, 200);
  // }, []);
  return (
    <div style={{position:"relative"}}>
      <FloatingAdd onclick={handleOpen} />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Typography variant="h5" gutterBottom>
            Add {
              formType === "room_expense" ? "Room Expense" : "Home Expense"
            }
            </Typography>
            <br></br>
            {
              formType === "room_expense" ? <ExpenseForm handleClose={handleClose} /> : <HomeExpenseForm handleClose={handleClose} />
            }
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
